import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { ButtonLink } from './Button';
import { WHATSAPP_URL } from '../data/site';
import { SECTION_IDS, SectionId, scrollToSection } from '../utils/scroll';
const navItems: {
  label: string;
  id: SectionId;
}[] = [{
  label: 'Cómo funciona',
  id: SECTION_IDS.proceso
}, {
  label: 'Servicios',
  id: SECTION_IDS.servicios
}, {
  label: 'Testimonios',
  id: SECTION_IDS.testimonios
}, {
  label: 'Preguntas',
  id: SECTION_IDS.preguntas
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const go = (id: SectionId) => {
    setOpen(false);
    scrollToSection(id);
  };
  return <header className={`sticky top-0 z-50 transition-[background-color,box-shadow,border-color] duration-200 ease-premium ${scrolled ? 'border-b border-lavender-200/70 bg-cream/80 shadow-hair backdrop-blur-md' : 'border-b border-transparent bg-cream/60 backdrop-blur-sm'}`} data-id="element-73" data-mp="2wm5rqy80yyzi">
      <div className="mx-auto flex max-w-content items-center justify-between gap-4 px-5 py-3 sm:px-8 lg:py-3.5" data-id="element-74" data-mp="2hpyaa5o04bnx">
        <a href="#top" className="rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-plum-700" aria-label="Inkova Business Consulting & Creation" data-id="element-75" data-mp="3acizazh08bob">
          <Logo data-id="element-76" data-mp="30lodtxbl1g3x" />
        </a>

        <nav aria-label="Principal" className="hidden lg:flex items-center gap-9" data-id="element-77" data-mp="30kd7pqunzw9n">
          {navItems.map(item => <button key={item.id} type="button" onClick={() => go(item.id)} className="group relative py-1 text-sm text-muted transition-colors duration-200 ease-premium hover:text-plum-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-plum-700" data-id="element-78" data-mp="3tb3k69saykti">
              {item.label}
              <span aria-hidden="true" className="absolute -bottom-0.5 left-0 h-px w-full origin-left scale-x-0 bg-plum-700 transition-transform duration-200 ease-premium group-hover:scale-x-100" data-id="element-79" data-mp="1mmuwszezv72p" />
            </button>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-80" data-mp="1cmc7vq8kp0dx">
          <ButtonLink analyticsId="header_whatsapp" href={WHATSAPP_URL} className="hidden whitespace-nowrap sm:inline-flex" onClick={() => setOpen(false)} data-id="element-81" data-mp="ypxj521ssrcv">
            Quiero comenzar
          </ButtonLink>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-movil" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="lg:hidden inline-flex h-11 w-11 items-center justify-center rounded-pill border border-lavender-200 bg-ivory/70 text-plum-900 transition-colors duration-200 ease-premium hover:bg-ivory" data-id="element-82" data-mp="2y1rnedqtu4c6">
            {open ? <XIcon className="h-5 w-5" data-id="element-83" data-mp="rcg8ct8dgk4e" /> : <MenuIcon className="h-5 w-5" data-id="element-84" data-mp="1555vx23jtx3m" />}
          </button>
        </div>
      </div>

      <AnimatePresence initial={false} data-id="element-85" data-mp="156z3cjlzklco">
        {open && <motion.div id="menu-movil" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:hidden overflow-hidden border-t border-lavender-200/70 bg-cream/95 backdrop-blur-md" data-id="element-86" data-mp="1059rx2uuq5o2">
            <nav aria-label="Principal móvil" className="mx-auto max-w-content px-5 py-1 sm:px-8" data-id="element-87" data-mp="3bwngjeylovou">
              {navItems.map(item => <button key={item.id} type="button" onClick={() => go(item.id)} className="block w-full border-b border-lavender-200/70 py-4 text-left text-base text-plum-900 last:border-0" data-id="element-88" data-mp="230rssdypgcjb">
                  {item.label}
                </button>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}